/** Allocate once when a genuinely new line is created, never while submitting. */
export function createHourEntryId() {
    if (typeof crypto.randomUUID === 'function')
        return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export function hourWriteRefreshMessage(error) {
    if (error.code === 'HOURS_WEEK_CHANGED') {
        return 'This week was changed in another session. Nothing from this draft was saved. Your input is still visible; reload and compare the saved hours before entering it again.';
    }
    if (error.code === 'HOURS_REFRESH_REQUIRED') {
        return 'This page is missing the current week version. Your input is still visible; reload the page before saving again.';
    }
    if (error.code === 'HOUR_WRITE_OUTCOME_UNCERTAIN' || error.status === 0 || error.status >= 500) {
        return 'The portal cannot confirm whether these hours were saved. Your input is still visible; reload and check the saved hours before entering anything again to avoid duplicates.';
    }
    return null;
}
